import { render, staticRenderFns } from "./DownloadPurchases.vue?vue&type=template&id=8899753c&"
import script from "./DownloadPurchases.vue?vue&type=script&lang=js&"
export * from "./DownloadPurchases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports